import styled from "styled-components";

const RoadmapCss = styled.div`
  background: linear-gradient(180deg, #0a171a 0%, #143237 53.12%, #255862 100%);

  .wrapper {
    .title {
      transform: translateX(-100%);
      transition: 2s ease;
      padding-top: 1em;
      margin-bottom: 0rem;
      // @media (max-width: 1700px) {
      //   margin-bottom: -4rem;
      // }
      color: white;
      font-family: Poppins;
      font-size: 40px;
      font-style: normal;
      font-weight: 300;
      line-height: 60px;
      letter-spacing: 0em;
      text-align: center;
      &.fadeIn {
        transform: translateX(0%);
        opacity: 1;
      }
      @media (max-width: 1700px) {
        font-size: 35px;
        // padding-bottom: 0;
      }
      @media (max-width: 800px) {
        font-size: 32px;
      }
      @media (max-width: 600px) {
        font-size: 26px;
      }
      @media (max-width: 400px) {
        font-size: 24px;
      }
    }
    .icons {
      padding: 2rem 13rem;
      display: flex;
      justify-content: space-around;
      @media (max-width: 800px) {
        padding: 1rem 6rem 1rem 6rem;
      }
      @media (max-width: 600px) {
        flex-wrap: wrap;
        padding: 1rem 3rem 1rem 3rem;
      }
      .foot {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        transition: transform 0.5s;
        &:hover {
          transform: scale(1.2);
        }

        @media (max-width: 1700px) {
          img {
            width: 45px;
          }
        }
        @media (max-width: 800px) {
          img {
            width: 35px;
          }
        }
        @media (max-width: 600px) {
          flex: 20vw;
          img {
            flex: 0.9;
            width: 30px;
          }
          padding-left: 10px;
          padding-right: 10px;
          padding-bottom: 7px;
        }
        p {
          flex: 0.1;
          // padding-top: 1rem;
          font-family: Poppins;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
          letter-spacing: 0em;
          color: rgba(204, 213, 232, 1);
          @media (max-width: 1700px) {
            font-size: 12px;
          }
          @media (max-width: 800px) {
            font-size: 10px;
          }
          @media (max-width: 600px) {
            font-size: 8px;
          }
        }
      }
    }
  }
`;

export default RoadmapCss;
